/* import __COLOCATED_TEMPLATE__ from './author.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();